import { emptyDate } from './sessionLogs.constants';
import { SessionLogsActionTypes, SessionLogsState } from './sessionLogs.types';

const sessionLogsInitialState: SessionLogsState = {
  search: null,
  date: emptyDate,
  type: null,
  accountId: null
};

const sessionLogsReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = sessionLogsInitialState,
  action: SessionLogsActionTypes
): SessionLogsState => {
  switch (action.type) {
    case 'UPDATE_FILTERS':
      return {
        ...state,
        ...action.payload
      } as SessionLogsState;

    case 'CLEAR_FILTERS':
      return {
        ...sessionLogsInitialState,
        date: {
          from: null,
          to: null
        }
      } as SessionLogsState;

    default:
      return state;
  }
};

export default sessionLogsReducer;
